/**
 * Delivery Date Calculator — Shared utility
 * Used by: custom-product-carousel, custom-product-grid, main-product
 *
 * Auto-initializes all [data-delivery-card] elements on DOM ready.
 * For dynamically added elements call:
 *   window.DeliveryDateUtils.init(scopeElement)
 *   window.DeliveryDateUtils.processElement(element)
 */
(function () {
  'use strict';

  function calculateDeliveryDate(startDate, daysToAdd, includeSaturday, cutoffHour) {
    var d = new Date(startDate);
    
    // 1️⃣ Apply cutoff (UK time)
    if (cutoffHour !== undefined && cutoffHour !== null) {
      try {
        var ukHour = parseInt(new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          hour: 'numeric',
          hour12: false
        }).format(new Date()));

        if (ukHour >= cutoffHour) {
          d.setDate(d.getDate() + 1);
        }
      } catch (e) {
        console.error('Delivery utility: UK time error', e);
      }
    }

    function isDispatchDay(date) {
      var dow = date.getDay();
      return dow !== 0 && dow !== 6;
    }

    function isDeliveryDay(date) {
      var dow = date.getDay();
      if (includeSaturday) return dow !== 0;
      return dow !== 0 && dow !== 6;
    }

    // 2️⃣ Normalize start date to next dispatch day (Mon-Fri only)
    while (!isDispatchDay(d)) {
      d.setDate(d.getDate() + 1);
    }

    // 3️⃣ Add delivery days
    var added = 0;
    while (added < daysToAdd) {
      d.setDate(d.getDate() + 1);
      if (isDeliveryDay(d)) added++;
    }

    return d;
  }

  function formatDeliveryDate(date, format) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var dayName = days[date.getDay()];
    var monthName = months[date.getMonth()];
    var dom = date.getDate();
    var suffix = 'th';
    if (dom === 1 || dom === 21 || dom === 31) suffix = 'st';
    else if (dom === 2 || dom === 22) suffix = 'nd';
    else if (dom === 3 || dom === 23) suffix = 'rd';
    var dateStr = monthName + ' ' + dom + suffix;
    if (format === 'day_only') return dayName;
    if (format === 'date_only') return dateStr;
    return dayName + ', ' + dateStr;
  }

  /**
   * Process a single delivery element.
   * Reads data-* attributes and updates the text span with the calculated date.
   * @param {HTMLElement} el — element marked with [data-delivery-card]
   */
  function processElement(el) {
    var mode = el.getAttribute('data-mode') || 'dynamic';
    if (mode !== 'dynamic') return;

    var daysToAdd = parseInt(el.getAttribute('data-days')) || 2;
    var includeSat = el.getAttribute('data-include-saturday') === 'true';
    var dateFormat = el.getAttribute('data-format') || 'day_date';
    var prefix = el.getAttribute('data-dynamic-text') || 'Get it by';
    var cutoffHour = el.getAttribute('data-cutoff-hour') ? parseInt(el.getAttribute('data-cutoff-hour')) : null;

    var span = el.querySelector('[data-delivery-text]');
    if (!span) return;

    var deliveryDate = calculateDeliveryDate(new Date(), daysToAdd, includeSat, cutoffHour);
    var newText = prefix + ' ' + formatDeliveryDate(deliveryDate, dateFormat);

    if (span.textContent !== newText) {
      span.textContent = newText;
    }
  }

  /**
   * Initialise all [data-delivery-card] elements within a scope.
   * @param {HTMLElement} [scope] — optional container; defaults to document
   */
  function init(scope) {
    var root = scope || document;
    var elements = root.querySelectorAll('[data-delivery-card]');
    for (var i = 0; i < elements.length; i++) {
      processElement(elements[i]);
    }
  }

  // Auto-init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Expose for external use
  window.DeliveryDateUtils = {
    init: init,
    processElement: processElement,
    calculateDate: calculateDeliveryDate,
    formatDate: formatDeliveryDate
  };
})();
